<template>
  <div>
    <div
      ref="map"
      class="me-map"
    />

    <modal-v2
      ref="consent"
      title="Atenção"
      auto-body-height
      close-on-click-outside
    >
      <template #body>
        <p>
          Para o funcionamento correto desta página, é necessário aceitar os <b class="font-bold">cookies funcionais</b>.
        </p>
      </template>

      <template #footer>
        <button
          class="mui-button mui-button--primary"
          @click="handleConsentModal"
        >
          Abrir as configurações
        </button>
      </template>
    </modal-v2>

    <mui-loader-full-page :is-active="loading" />

    <stacked-toast ref="toasts" />
  </div>
</template>

<script>
/** MIXINS */
import PostUnitsMap from './mixins/PostUnitsMap';

/** COMPONENTS */
import ModalV2 from "commons/js/components/atoms/ModalV2.vue";
import MuiLoaderFullPage from "commons/js/components/MUI/loaders/MUILoaderFullPage/MUILoaderFullPage.vue"
import StackedToast from "commons/js/components/atoms/StackedToast";

export default {
  components: {
    ModalV2,
    MuiLoaderFullPage,
    StackedToast,
  },

  mixins: [
    PostUnitsMap,
  ],
};
</script>
